var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckmarkGreen = function SvgCheckmarkGreen(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 8,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF8000",
    fillRule: "evenodd",
    d: "m4.451 7.703 6.31-5.82a.167.167 0 0 0 .002-.238L9.476.361a.166.166 0 0 0-.235 0L4.452 4.843a.167.167 0 0 1-.232.003L1.756 2.737a.167.167 0 0 0-.233.003L.236 4.029a.167.167 0 0 0 .004.239l3.982 3.437c.065.06.166.06.23-.002",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmarkGreen);
export default ForwardRef;